"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _babelHelperVueJsxMergeProps = _interopRequireDefault(require("@vue/babel-helper-vue-jsx-merge-props"));
var _defineProperty2 = _interopRequireDefault(require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _department = require("@/api/crm/department");
var _vueTypes = _interopRequireDefault(require("ant-design-vue/es/_util/vue-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _InputDeptSearch = _interopRequireDefault(require("./InputDeptSearch"));
require("./style.scss");
var _class, _dec, _class2, _AddUserModal;
const AddUserModalProps = {
  /**
   * @type {(ids:string[], records:object[])=>Promise<any>}
   * 提交操作
   */
  action: _vueTypes.default.func,
  alert: _vueTypes.default.bool.def(false),
  getDeptSearch: _vueTypes.default.func.def(_department.getDepartmentTree),
  getUserList: _vueTypes.default.func.isRequired,
  /** @type {string} ATable.type 表格组件多选与单选 */
  type: _vueTypes.default.oneOf(['checkbox', 'radio'])
};
let AbstractModal = (0, _vuePropertyDecorator.Component)(_class = class AbstractModal extends _vuePropertyDecorator.Vue {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "formData", {});
    (0, _defineProperty2.default)(this, "loading", false);
    (0, _defineProperty2.default)(this, "visible", false);
  }
  show(data) {
    this.visible = true;
    if (data) {
      this.formData = _lodash.default.cloneDeep(data);
    }
  }
  close() {
    this.visible = false;
    this.clear();
  }
  clear() {
    this.selection = [];
    this.formData = {};
    this.loading = false;
    this.dataSource = [];
  }
}) || _class;
let AddUserModal = exports.default = (_dec = (0, _vuePropertyDecorator.Component)({
  props: {
    ...AddUserModalProps
  },
  inheritAttrs: false
}), _dec(_class2 = (_AddUserModal = class AddUserModal extends AbstractModal {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "deptTreeData", []);
    (0, _defineProperty2.default)(this, "searchParams", _lodash.default.clone(AddUserModal.SEARCH_PARAMS_EMPTY));
    (0, _defineProperty2.default)(this, "isSidebarLoading", false);
    (0, _defineProperty2.default)(this, "isContentLoading", false);
    (0, _defineProperty2.default)(this, "tableConfig", {
      enablePagination: false,
      showHandler: false,
      handlerColumn: {
        width: 120
      },
      enableMultiSelect: true,
      rowKey: 'id'
    });
    (0, _defineProperty2.default)(this, "dataSource", []);
    (0, _defineProperty2.default)(this, "tbLoading", false);
    (0, _defineProperty2.default)(this, "selection", []);
    (0, _defineProperty2.default)(this, "page", {
      size: 15,
      current: 1,
      total: 0,
      pageSizeOptions: ['15', '30', '50', '100']
    });
  }
  show(data) {
    this.refresh(true);
    // super.show(data)
    this.selection = [];
    AbstractModal.options.methods.show.call(this, data);
  }
  handleSubmit() {
    const rows = _lodash.default.cloneDeep(this.selection);
    const ids = rows.map(it => it.id).join(',');
    if (_lodash.default.isEmpty(ids)) {
      this.$message.warning('请选择数据');
      return;
    }
    this.close();
    this.$emit('submit', ids, rows);
  }
  async refresh(force) {
    try {
      this.isSidebarLoading = true;
      this.isContentLoading = true;
      this.deptTreeData = await (0, _department.getDepartmentTree)();
      if (_lodash.default.head(this.deptTreeData)) {
        if (force) {
          this.searchParams.deptId = _lodash.default.head(this.deptTreeData).id;
        }
      }
      this.isSidebarLoading = false;
      this.tableRefresh(force);
    } finally {
      this.isSidebarLoading = false;
      this.isContentLoading = false;
    }
  }
  clear() {
    this.searchParams = _lodash.default.clone(this.constructor.SEARCH_PARAMS_EMPTY);
    this.selection = [];
  }
  // 表格选择
  onTableSelect(selection) {
    this.selection = selection;
  }
  async tableRefresh(force) {
    let {
      size: pageSize,
      current: pageNo
    } = this.page;
    if (force) {
      pageSize = 15;
      pageNo = 1;
    }
    this.tbLoading = true;
    const res = await this.getUserList({
      pageNo,
      pageSize,
      ..._lodash.default.pick(this.searchParams, ['deptId', 'userId'])
    });
    this.dataSource = res.records;
    this.page.total = res.total;
    this.tbLoading = false;
  }
  renderSidebar() {
    const h = this.$createElement;
    const {
      isSidebarLoading: loading,
      deptTreeData: list,
      searchParams: {
        deptId
      }
    } = this;
    return h("div", {
      "class": "sidebar"
    }, [h(_InputDeptSearch.default, {
      "attrs": {
        "userId": this.searchParams.userId,
        "deptId": this.searchParams.deptId,
        "data": this.getDeptSearch
      },
      "on": {
        "search": e => {
          if (e.deptId) {
            this.searchParams.deptId = e.deptId;
          }
          this.searchParams.userId = e.userId;
          this.refresh();
        }
      }
    }), h("AEmpty", {
      "directives": [{
        name: "show",
        value: _lodash.default.isEmpty(list) && !loading
      }]
    }), h("div", {
      "class": "sidebar__scroll"
    }, [h("ASpin", {
      "attrs": {
        "spinning": loading
      }
    }, [h("ATree", {
      "attrs": {
        "defaultExpandAll": true,
        "selectedKeys": _lodash.default.compact([deptId]),
        "replaceFields": {
          title: 'deptName',
          key: 'id'
        },
        "treeData": list
      },
      "key": list.length,
      "on": {
        "select": keys => {
          // 阻止取消选中部门 (点击选中的部门，会取消选中)
          if (_lodash.default.isEmpty(keys)) {
            return;
          }
          ;
          [this.searchParams.deptId] = keys;
          this.tableRefresh(true);
        }
      }
    })])])]);
  }
  renderContent() {
    const h = this.$createElement;
    const {
      dataSource
    } = this;
    const options = {
      columns: [{
        label: '姓名',
        prop: 'name'
      }, {
        label: ' 工号 ',
        prop: 'jobNumber'
      }, {
        label: ' 部门 ',
        prop: 'deptNames'
      }],
      dataSource,
      isToolbar: false,
      isSearchPanel: false,
      isSelection: true,
      isAction: false,
      scroll: false
    };
    return h("div", {
      "class": "content"
    }, [h("ASpin", {
      "attrs": {
        "spinning": this.tbLoading
      }
    }, [h("CommonTable", {
      "ref": "basic-config-table",
      "class": "basic-config-table",
      "attrs": {
        "maxHeight": "480",
        "columns": options.columns,
        "config": this.tableConfig,
        "data": options.dataSource
      },
      "on": {
        "select": this.onTableSelect,
        "selectAll": this.onTableSelect
      }
    }), h("div", {
      "class": "m-flex m-row-between m-p-t-16"
    }, [h("APagination", {
      "attrs": {
        "size": "small",
        "total": this.page.total,
        "pageSize": this.page.size,
        "pageSizeOptions": this.page.pageSizeOptions,
        "showSizeChanger": true,
        "showQuickJumper": true
      },
      "on": {
        "change": page => {
          this.page.current = page;
          this.tableRefresh(false);
        },
        "showSizeChange": size => {
          this.page.size = size;
          this.tableRefresh(false);
        }
      },
      "model": {
        value: this.page.current,
        callback: $$v => {
          this.$set(this.page, "current", $$v);
        }
      }
    })])])]);
  }
  render() {
    const h = arguments[0];
    // vm.$attrs 直接绑定在 AModal 上，用于配置模态窗属性
    const {
      loading,
      visible,
      close,
      handleSubmit,
      renderSidebar,
      renderContent,
      $attrs
    } = this;
    return h("AModal", (0, _babelHelperVueJsxMergeProps.default)([{
      "class": "oa-page-role-setting",
      "attrs": {
        "confirmLoading": loading,
        "destroyOnClose": true,
        "wrapClassName": "oa-add-user-modal",
        "width": 1000,
        "visible": visible
      }
    }, {
      "props": {
        title: '添加员工',
        ...$attrs
      }
    }, {
      "on": {
        "cancel": close,
        "ok": handleSubmit
      }
    }]), [/** table.selectedRows 会失去引用造成页面不更新, 使用 table.selectedRowKeys */
    this.alert && this.$refs.table && !!this.$refs.table.selectedRowKeys.length && h("AAlert", {
      "class": "mb-md pr-lg",
      "directives": [{
        name: "show",
        value: _lodash.default.size(this.$refs.table.selectedRows)
      }],
      "attrs": {
        "afterClose": () => {
          this.selection = [];
        },
        "closable": true,
        "message": `已选择: ${_lodash.default.map(this.selection.selectedRows, 'name')}`
      }
    }), h("div", {
      "class": "oa-add-user-modal__container"
    }, [renderSidebar(), renderContent()])]);
  }
}, (0, _defineProperty2.default)(_AddUserModal, "SEARCH_PARAMS_EMPTY", {
  deptId: null,
  userId: null
}), (0, _defineProperty2.default)(_AddUserModal, "props", AddUserModalProps), _AddUserModal)) || _class2);